import { render } from "./pdf.vue?vue&type=template&id=edc6e222"
import script from "./pdf.vue?vue&type=script&lang=ts"
export * from "./pdf.vue?vue&type=script&lang=ts"
script.render = render

export default script